/**
 * Route prefixes that do not require an authenticated Clerk session.
 * The root route guard (`routes/__root.tsx`) skips its sign-in redirect for
 * any pathname matching one of these prefixes. `/waitlist` is public so gated
 * visitors can join the waitlist without being bounced to sign-in.
 *
 * '/s/' (trailing slash REQUIRED) matches public share links `/s/<token>`
 * without also matching `/settings` or `/sign-in`. `/shared/<id>` stays
 * authenticated (recipients must be signed in), so it is NOT listed here.
 *
 * '/try' is public so the anonymous try editors ("taste version") are
 * reachable without a session; the /try routes enforce their own launch
 * gate in beforeLoad (see src/config/try-editors.ts).
 *
 * '/whats-new' is public so release notes can be shared and linked from
 * outside the app.
 */
export const PUBLIC_ROUTE_PREFIXES = ['/sign-in', '/sign-up', '/waitlist', '/privacy', '/terms', '/licenses', '/s/', '/try', '/whats-new'];

/** True when `pathname` starts with any public route prefix. */
export function isPublicRoute(pathname: string): boolean {
    return PUBLIC_ROUTE_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}
